import { SET_LEAD_SOURCE_SOURCE_TYPE } from 'actions';

export function setLeadSourceSourceType(sourceType: string) {
  return { sourceType, type: SET_LEAD_SOURCE_SOURCE_TYPE };
}
